import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar, Clock, MapPin, Users, ExternalLink } from 'lucide-react';
import BreathingRoomServices from '../components/BreathingRoomServices';

const WELLNESSLIVING_URL = "https://www.wellnessliving.com/rs/schedule/breathing_room-rws2se?k_business=731965";

const EventsPage = () => {
  const allEvents = [
    {
      title: '28 Day Stress Reset',
      isoDate: '2026-05-28',
      description: 'Discover the incredible world of fascia and how this connective tissue system impacts every aspect of your health. Over 28 days, you\'ll learn targeted techniques to release fascial restrictions and restore fluid movement.',
      date: 'May 1 – May 28, 2026',
      time: 'Live 7am Weekdays | 8am Weekends',
      location: 'Online Program',
      type: 'Program',
      spots: '$252',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=957840&k_class_tab=75840',
      hasReadMore: true,
      readMoreLink: '/programs',
      image: 'https://customer-assets.emergentagent.com/job_hello-start-57/artifacts/44jdhqpq_Untitled%20%28Instagram%20Post%20%2845%29%29%20%281%29.png',
    },
    {
      title: 'Free Fascia Event',
      isoDate: '2026-02-28',
      description: 'Join us In Studio for a Free Fascia Event as a lead into The 28 Day Reset. Grab this opportunity to explore this practice with us. Stay for our meditation post event ($20) — we are hoping to bring you a very unique meditation experience!',
      date: 'February 28, 2026',
      time: '10:00 AM - 11:30 AM',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Free Event',
      spots: 'Limited Spots',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=925981&k_class_tab=75840',
      image: 'https://customer-assets.emergentagent.com/job_hello-start-57/artifacts/57kuj3b4_In%20Studio%20-%209%20Par%20La%20Ville%20Lower%20Level.png',
    },
    {
      title: 'Movie Night: Inception',
      isoDate: '2026-03-27',
      description: 'Join us for Movie Night at the Breathing Room! This month we\'re watching Inception. Mocktail and a snack included with your ticket. Movie only $10 (snack and drink incl), Full evening $30, Class only $25.',
      date: 'March 27, 2026',
      time: '6:30 PM',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Social Event',
      spots: 'Movie $10 | Full Evening $30 | Class $25',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=851418&k_class_tab=75840',
      image: 'https://customer-assets.emergentagent.com/job_34f346c1-11e1-4dd6-9352-e802879059af/artifacts/ggtgjmo3_ChatGPT%20Image%20Mar%2010%2C%202026%2C%2004_20_12%20PM.png',
    },
    {
      title: 'Changing Our Relationship With Pain',
      isoDate: '2026-02-28',
      description: 'Living with pain is no fun. Did you know pain is a center in the brain? Emotional, mental, spiritual, intuitive, physical pain — it\'s all the same to the brain! So what happens when we de-stimulate that center? Join us to find out. Pain isn\'t the enemy. Our relationship with it often is.',
      date: 'February 28, 2026',
      time: '12:00 PM - 3:00 PM',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Workshop',
      spots: 'Limited Spots',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=922589&k_class_tab=75840',
      image: 'https://customer-assets.emergentagent.com/job_hello-start-57/artifacts/hksh2ix0_Khaki%20Photo%20Minimalist%20Modern%20Travel%20Pinterest%20Post.png',
    },

    // ── Migrated from the events calendar (one-time events) ──
    {
      title: 'Social / Mingle Event',
      isoDate: '2026-06-03',
      description: 'A relaxed evening to gather, mingle, and connect. More details soon.',
      date: 'June 3, 2026',
      time: 'Evening',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Social Event',
      spots: 'Limited Spots',
      bookingUrl: WELLNESSLIVING_URL,
    },
    {
      title: 'Empath Enhancement Guide',
      isoDate: '2026-06-08',
      description: 'A deeper understanding of sensitivity as awareness… not overwhelm. Part of the Wisdom & Weirdness series.',
      date: 'June 8, 2026',
      time: '5:30pm · 90 min',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Workshop',
      spots: 'Wisdom & Weirdness',
      bookingUrl: WELLNESSLIVING_URL,
    },
    {
      title: 'Alignment Series: Integrating Pelvis, Spine, and Shoulders',
      isoDate: '2026-06-10',
      description: 'Reclaiming the center of the body and integrating the pelvis with the spine and shoulders for whole-body alignment. Restore movement, breath, and connection through the structures that hold us up.',
      date: 'June 10, 2026',
      time: '5:30pm · 90 min',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Workshop',
      spots: '$35 · Alignment Series',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=846786&k_class_tab=75840',
    },
    {
      title: 'Alignment Series: The Power of Breathing & Connecting to the Deeper Core',
      isoDate: '2026-06-17',
      description: 'Beyond strength… into connection. This is not about sit-ups. This is about reconnecting to the core closest to the skeleton.',
      date: 'June 17, 2026',
      time: '5:30pm · 90 min',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Workshop',
      spots: '$35 · Alignment Series',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=846786&k_class_tab=75840',
    },
    {
      title: 'I Gotta Get My Shift Together',
      isoDate: '2026-06-22',
      description: 'Does your life feel a little…off track? Not necessarily chaos — maybe you\'re simply ready for more clarity, direction, momentum, or alignment. Join us for a practical, thought-provoking exploration of life, goals, patterns, and what might actually be getting in the way. We\'ll blend nervous system regulation, practical life tools, a little subconscious exploration, and a simple framework to help you focus your energy where it matters most. If you\'ve been feeling stuck, scattered, overwhelmed, or simply ready for a new chapter — come join us. Small shifts. BIG changes.',
      date: 'June 22, 2026',
      time: '5:30pm · 90 min',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Workshop',
      spots: 'Life Coaching',
      bookingUrl: 'https://www.wellnessliving.com/rs/appointment-new/breathing_room-rws2se',
    },
    {
      title: 'Flex Detox — Info Session',
      isoDate: '2026-06-22',
      description: 'What if wellness didn\'t have to be all or nothing? Come learn about the Flex Detox — a flexible, choose-your-pace 21-day holistic detox. Flatten the bloat, free your energy, and rebuild your habits. Your path. Your pace. Your wellness.',
      date: 'June 22, 2026',
      time: '1:10pm · 45 min',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Free Event',
      spots: 'Free Info Session',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=981136&k_class_tab=75840',
      bookingLabel: 'Sign Up',
    },
    {
      title: 'Alignment Series: Spinal Freedom',
      isoDate: '2026-06-24',
      description: 'Stability + mobility… at the same time. The spine is meant to move in multiple directions, yet most of us live in limited patterns. Reclaim freedom of movement through the whole spine.',
      date: 'June 24, 2026',
      time: '5:30pm · 90 min',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Workshop',
      spots: '$35 · Alignment Series',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=846786&k_class_tab=75840',
    },
    {
      title: 'M.E. Wellness',
      isoDate: '2026-06-29',
      description: 'An exploration of wellness through the Wisdom & Weirdness lens. More details soon.',
      date: 'June 29, 2026',
      time: '5:30pm · 90 min',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Workshop',
      spots: 'Wisdom & Weirdness',
      bookingUrl: WELLNESSLIVING_URL,
    },
    {
      title: 'Flex Detox — Info Session',
      isoDate: '2026-06-29',
      description: 'What if wellness didn\'t have to be all or nothing? Come learn about the Flex Detox — a flexible, choose-your-pace 21-day holistic detox. Flatten the bloat, free your energy, and rebuild your habits. Your path. Your pace. Your wellness.',
      date: 'June 29, 2026',
      time: '5:30pm · 45 min',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Free Event',
      spots: 'Free Info Session',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=981136&k_class_tab=75840',
      bookingLabel: 'Sign Up',
    },
    {
      title: 'Flex Detox — Info Session',
      isoDate: '2026-06-30',
      description: 'What if wellness didn\'t have to be all or nothing? Come learn about the Flex Detox — a flexible, choose-your-pace 21-day holistic detox. Flatten the bloat, free your energy, and rebuild your habits. Your path. Your pace. Your wellness.',
      date: 'June 30, 2026',
      time: '1:15pm · 45 min',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Free Event',
      spots: 'Free Info Session',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=981136&k_class_tab=75840',
      bookingLabel: 'Sign Up',
    },
    {
      title: 'Flex Detox Begins',
      isoDate: '2026-07-01',
      description: 'The Flex Detox program runs July 1–21. A flexible, choose-your-pace 21-day holistic detox — choose your pace, your level of support, and your focus. Flatten the bloat, free your energy, and rebuild your habits.',
      date: 'July 1–21, 2026',
      time: 'All Day · 21-day program',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Program',
      spots: '21-Day Program',
      bookingUrl: 'https://www.wellnessliving.com/rs/event/breathing_room-rws2se?k_class=981136&k_class_tab=75840',
      bookingLabel: 'Sign Up',
    },
    {
      title: 'Empath Enhancement Guide',
      isoDate: '2026-07-06',
      description: 'A deeper understanding of sensitivity as awareness… not overwhelm. An evening session to strengthen and steady the sensitive nervous system. Part of the Wisdom & Weirdness series.',
      date: 'July 6, 2026',
      time: '5:30–7:30pm · 2 hr',
      location: 'Breathing Room Bermuda',
      locationDetails: '9 Par La Ville, Hamilton, Bermuda - Lower Level',
      type: 'Workshop',
      spots: 'Wisdom & Weirdness',
      bookingUrl: WELLNESSLIVING_URL,
    },
  ];

  const getEventTypeStyle = (type) => {
    switch(type) {
      case 'Program': return 'bg-terracotta/10 text-terracotta';
      case 'Free Event': return 'bg-green-100 text-green-700';
      case 'Social Event': return 'bg-amber-100 text-amber-700';
      case 'Workshop': return 'bg-purple-100 text-purple-700';
      default: return 'bg-forest/10 text-forest';
    }
  };

  const getButtonStyle = (type) => {
    switch(type) {
      case 'Free Event': return 'bg-green-600 hover:bg-green-700';
      case 'Social Event': return 'bg-amber-600 hover:bg-amber-700';
      default: return 'bg-forest hover:bg-forest-dark';
    }
  };

  const getButtonText = (type) => {
    switch(type) {
      case 'Free Event': return 'Sign Up Free';
      case 'Program': return 'Learn More';
      default: return 'Register Now';
    }
  };

  // Split events into upcoming vs. past based on today's date
  const todayIso = new Date().toISOString().split('T')[0];
  const upcomingEvents = allEvents
    .filter((e) => e.isoDate >= todayIso)
    .sort((a, b) => a.isoDate.localeCompare(b.isoDate));
  const pastEvents = allEvents
    .filter((e) => e.isoDate < todayIso)
    .sort((a, b) => b.isoDate.localeCompare(a.isoDate));

  const renderEventCard = (event, index, isPast = false) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: index * 0.1 }}
      data-testid={`${isPast ? 'past-event' : 'upcoming-event'}-${index + 1}`}
      className={`bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 ${isPast ? 'opacity-70' : ''}`}
    >
      <div className="flex flex-col lg:flex-row">
        {/* Event Image */}
        {event.image && (
          <div className="lg:w-72 h-48 lg:h-auto flex-shrink-0">
            <img
              src={event.image}
              alt={event.title}
              className="w-full h-full object-cover"
            />
          </div>
        )}

        {/* Event Content */}
        <div className={`flex-1 p-6 md:p-8 flex flex-col lg:flex-row lg:items-center gap-6 ${!event.image ? 'border-l-4 border-terracotta/40' : ''}`}>
          <div className="flex-1">
            <span className={`inline-block px-3 py-1 rounded-full font-body text-xs tracking-wide uppercase mb-3 ${getEventTypeStyle(event.type)}`}>
              {event.type}
            </span>
            <h3 className="font-heading text-2xl text-forest mb-3">
              {event.title}
            </h3>
            <p className="text-stone-600 font-body leading-relaxed mb-4">
              {event.description}
            </p>
            <div className="flex flex-wrap gap-4 text-stone-500 font-body text-sm">
              <span className="flex items-center gap-2">
                <Calendar size={16} className="text-terracotta" />
                {event.date}
              </span>
              <span className="flex items-center gap-2">
                <Clock size={16} className="text-terracotta" />
                {event.time}
              </span>
              <span className="flex items-center gap-2">
                <MapPin size={16} className="text-terracotta" />
                {event.location}
              </span>
            </div>
            {event.locationDetails && (
              <p className="text-stone-400 text-xs mt-2 font-body">
                {event.locationDetails}
              </p>
            )}
          </div>

          {/* Action Area */}
          <div className="flex flex-col items-start lg:items-end gap-3 lg:min-w-[180px]">
            <span className="flex items-center gap-2 text-forest font-body text-sm">
              <Users size={16} />
              {event.spots}
            </span>
            {!isPast && (
              <a
                href={event.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={`${getButtonStyle(event.type)} text-white px-6 py-3 rounded-full font-body font-medium transition-all duration-300 inline-flex items-center gap-2`}
              >
                {event.bookingLabel || getButtonText(event.type)}
                <ExternalLink size={16} />
              </a>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );

  return (
    <div className="bg-cream pt-24" data-testid="events-page">
      {/* Compact Hero Section */}
      <section className="py-8 md:py-12">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-terracotta font-body text-sm tracking-widest uppercase mb-3">
              Events
            </p>
            <h1 className="font-heading text-4xl md:text-5xl text-forest leading-[1.1]">
              What's Happening
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Breathing Room — Services & Rates */}
      <BreathingRoomServices />

      {/* Upcoming Events */}
      {upcomingEvents.length > 0 && (
        <section className="py-12 md:py-16" data-testid="upcoming-events-section">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="mb-10"
            >
              <h2 className="font-heading text-3xl md:text-4xl text-forest">
                Upcoming Events
              </h2>
            </motion.div>

            <div className="space-y-8">
              {upcomingEvents.map((event, index) => renderEventCard(event, index, false))}
            </div>
          </div>
        </section>
      )}

      {/* Past Events */}
      {pastEvents.length > 0 && (
        <section className="py-12 md:py-16" data-testid="past-events-section">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="mb-10"
            >
              <h2 className="font-heading text-3xl md:text-4xl text-forest">
                Past Events
              </h2>
            </motion.div>

            <div className="space-y-8">
              {pastEvents.map((event, index) => renderEventCard(event, index, true))}
            </div>
          </div>
        </section>
      )}

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-stone-100">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="font-heading text-3xl md:text-4xl text-forest mb-6">
              Can't Make These Dates?
            </h2>
            <p className="text-stone-600 text-lg font-body leading-relaxed mb-8 max-w-2xl mx-auto">
              Private sessions are available on a flexible schedule. Or sign up 
              for the newsletter to be the first to know about new events.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href={WELLNESSLIVING_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="events-book-btn"
                className="bg-forest text-cream px-8 py-4 rounded-full font-body font-medium hover:bg-forest-dark transition-all duration-300 inline-flex items-center gap-2"
              >
                Book a Private Session
                <ArrowRight size={18} />
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default EventsPage;
